module.exports = __webpack_public_path__ + "img/photo-26.417ed292.jpg";